import { useMemo } from "react";
import { Polygon, Polyline, CircleMarker } from "react-leaflet";
import { useSelector } from "react-redux";
import { useParams } from 'react-router-dom'


import mapStateToProps from "./mapStateToProps"; 

const MapPoligonDrawing=()=>{
    const {
        geozoneVertexArr,
        geozoneArr,
    } = useSelector(mapStateToProps)

   
    const { zoneId } = useParams();

    // if (!rights?.['dirGeozones-edit']) return null

    const gId = parseInt(zoneId);
    const editedGeo = geozoneArr.find(({ id }) => gId === id)
    if (!editedGeo) return null

    

    
    // const outedArr = useMemo(()=>{
    //     if(!geozoneSettingsArr?.length) return null
    //     return geozoneArr.filter((item, i)=>(geozoneSettingsArr[i].active && item.polygon && item.polygon.length > 2))
    // }, [geozoneArr, geozoneSettingsArr])
    
    // if(!geozoneSettingsArr || !geozoneSettingsArr.length) return null
    return (
        <>
            {geozoneVertexArr?.length?(
                <CircleMarker  center={geozoneVertexArr.map(({x,y})=>[x,y])[0]} />
            ):null}
            {geozoneVertexArr?.length>1?(
                <Polyline pathOptions={{ color:editedGeo.color,  weight:6  }} positions={geozoneVertexArr.map(({x,y})=>[x,y])} />
            ):null}
            {geozoneVertexArr?.length>2?(
                <Polygon pathOptions={{ color:editedGeo.color, fill:true, weight:1, fillOpacity:.2 }} positions={geozoneVertexArr.map(({x,y})=>[x,y])} />
            ):null}
           
        </>
    )
}

export default MapPoligonDrawing